import type { Call } from "@/types/call.types";
import { hasStringProperty, isRecord } from "@/utils/type-guards";

import type { NotificationAdapter } from "./base/notification-adapter.interface";

const isValidCall = (obj: unknown): obj is Call => {
    if (!isRecord(obj)) return false;

    return (
        hasStringProperty(obj, "id") &&
        hasStringProperty(obj, "userId") &&
        hasStringProperty(obj, "orgId") &&
        hasStringProperty(obj, "calledNumber")
    );
};

const isCallNotificationPayload = (payload: unknown): payload is { call: Call } => {
    if (!isRecord(payload)) {
        return false;
    }

    if (!isValidCall(payload.call)) {
        return false;
    }

    return true;
};

export const createCallNotificationAdapter = (
    handleCallNotification: (call: Call) => void
): NotificationAdapter<{ call: Call }> => {
    return {
        canHandle: isCallNotificationPayload,
        process: (payload: unknown) => {
            if (isCallNotificationPayload(payload)) {
                handleCallNotification(payload.call);
            }
        },
    };
};
